import { Link } from 'react-router-dom';

const programs = [
  {
    id: 'architect-accelerator',
    cat: 'architecture leadership',
    img: 'https://leadwithtech.in/images/AspiringArchitectProgram.png',
    badge: 'Bestseller',
    title: 'The Architect Accelerator',
    rating: '4.6',
    desc: 'Transform your potential into leadership. Master the art of designing solutions that drive innovation and career success.',
    price: '\u20b924,999',
    was: '\u20b942,999',
    link: '/architect',
  },
  {
    id: 'copilot-masterclass',
    cat: 'ai copilot',
    img: 'https://leadwithtech.in/images/GHC.png',
    badge: 'Bestseller',
    title: 'Advanced GitHub Copilot Masterclass',
    rating: '4.5',
    desc: 'Unlock the power of AI in coding. Master GitHub Copilot through hands-on projects and build real-world solutions faster and smarter.',
    price: '\u20b93,999',
    was: '\u20b97,999',
    link: '/gh300',
  },
  {
    id: 'vibe-engineering',
    cat: 'ai vibe',
    img: 'https://leadwithtech.in/images/GHC.png',
    badge: 'Trending',
    title: 'Vibe Engineering Program',
    rating: '4.8',
    desc: 'Go beyond AI-assisted coding. Learn Context Engineering, AI Code Review, and the 5W Framework to ship production-ready code - not just fast code.',
    price: '\u20b924,999',
    was: '\u20b942,999',
    link: '/vibe-engineering',
  },
];

function HomeFlagshipSection() {
  return (
    <section className="band bg-light" id="flagship" aria-labelledby="flagship-title">
      <div className="wrap">
        <div className="head-block center">
          <p className="eyebrow">Mentor-Led Workshops</p>
          <h2 className="section-title" id="flagship-title" style={{ marginTop: '12px' }}>
            Flagship <span className="red">Programs</span>
          </h2>
          <p className="section-sub">Mentor-led workshops for software professionals who are serious about where their career is going.</p>
        </div>

        <div className="card-grid">
          {programs.map((p) => (
            <article className="pcard" key={p.id} data-cat={p.cat}>
              <div className="pcard-img ph" aria-hidden="true">
                <img src={p.img} alt={p.title} />
              </div>
              <div className="pcard-body">
                <div className="pcard-badges">
                  <span className="badge badge-workshop">Workshop</span>
                  <span className="badge badge-soft">{p.badge}</span>
                </div>
                <h3>{p.title}</h3>
                {/* <div className="rating">
                  <span className="s">\u2605</span> {p.rating}</div> */}
                <p className="desc">{p.desc}</p>
                <div className="pcard-foot">
                  <div className="price">
                    <span className="now">{p.price}</span>
                    <span className="was">{p.was}</span>
                  </div>
                  <Link className="btn btn-red btn-sm" to={p.link}>Explore Program</Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeFlagshipSection;
